import React, { useContext } from 'react';
import { IntlProvider } from 'react-intl';
import { appStore } from '../../state/app';
import English from '../../lang/en-US.json';
import Spanish from '../../lang/es-ES.json';
import France from '../../lang/fr-FR.json';

const userLanguage = navigator.language;
let setLanguage;
if (userLanguage === 'en-Us') {
  setLanguage = English;
} else if (userLanguage.includes('es')) {
  setLanguage = Spanish;
} else if (userLanguage.includes('fr')) {
  setLanguage = France;
} else {
  setLanguage = English;
}
const MultiLangWrapper = (props) => {
  const { children } = props;
  const { state } = useContext(appStore);
  const { app } = state;
  const { locales, messages } = app;

  return (
    <IntlProvider messages={messages || setLanguage} locale={locales} defaultLocale={locales}>
      {children}
    </IntlProvider>
  );
};

export default MultiLangWrapper;
